/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import Drawable from './Drawable'
import { Command, cmd } from '../Command'

export default class Path extends Drawable {

    constructor(frame) {
        super(frame)
        this._closed = false
        this._points = []
    }

    get closed() {
        return this._closed
    }

    set closed(val) {
        this._closed = val
    }

    get points() {
        return this._points
    }

    set points(val) {
        this._points = val
    }

    get cacheKey() {
        let key = super.cacheKey

        key += this.closed + '-'
        for (let pt of this.points) {
            key += pt.x + 'x' + pt.y + '-'
        }

        return key
    }

    get commands() {
        let cmds = [cmd(Command.Begin)]

        for (let pt of this.points) {
            if (cmds.length === 1) {
                cmds.push(cmd(Command.PathMoveTo, pt))
            } else {
                cmds.push(cmd(Command.PathLineTo, pt))
            }
        }

        if (this.closed) {
            cmds.push(cmd(Command.PathClose))
        }

        if (this.fill) {
            cmds.push(cmd(Command.Fill, this.fill))
        }

        if (this.stroke) {
            cmds.push(cmd(Command.Stroke, this.stroke, this.lineWidth))
        }

        return cmds
    }

}
